import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { HeartPulse, GraduationCap, Landmark, ShoppingBag, Factory, Building2, Plane, Car, Cpu, ArrowRight } from 'lucide-react';
import { useI18n } from '../../i18n';

const iconMap = { healthcare: HeartPulse, education: GraduationCap, finance: Landmark, retail: ShoppingBag, manufacturing: Factory, realestate: Building2, travel: Plane, automotive: Car, technology: Cpu };
const KEYS = ['healthcare','education','finance','retail','manufacturing','realestate','travel','automotive','technology'];

const Industries = ({ onBookCall }) => {
  const { t } = useI18n();
  return (
    <section id="industries" className="py-20 lg:py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <span className="text-xs font-semibold uppercase tracking-widest text-orange-600">{t('industries.kicker')}</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900">{t('industries.title')}</h2>
          <p className="mt-4 text-slate-600">{t('industries.body')}</p>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-5">
          {KEYS.map((k) => {
            const Icon = iconMap[k] || Cpu;
            return (
              <div key={k} className="group rounded-2xl bg-white p-6 border border-slate-200 hover:border-orange-300 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className="h-12 w-12 rounded-lg bg-orange-50 text-orange-600 flex items-center justify-center group-hover:bg-orange-500 group-hover:text-white transition-colors">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="mt-4 text-lg font-bold text-slate-900">{t(`industries.items.${k}.name`)}</h3>
                <p className="mt-1.5 text-sm text-slate-600">{t(`industries.items.${k}.desc`)}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-14 rounded-2xl border border-orange-200 bg-gradient-to-r from-orange-50 to-amber-50 p-8 lg:p-10 flex flex-col lg:flex-row items-center justify-between gap-6">
          <div>
            <div className="text-xs font-semibold uppercase tracking-widest text-orange-600">{t('industries.customKicker')}</div>
            <h3 className="mt-2 text-2xl sm:text-3xl font-bold text-slate-900">{t('industries.customTitle')}</h3>
            <p className="mt-2 text-slate-600 max-w-2xl">{t('industries.customBody')}</p>
          </div>
          <div className="flex gap-3">
            <Link to="/pricing" data-testid="choose-package-btn">
              <Button className="bg-slate-900 hover:bg-slate-800 text-white h-11 px-5">{t('common.choosePackage')}</Button>
            </Link>
            <Button onClick={onBookCall} className="bg-orange-500 hover:bg-orange-600 text-white h-11 px-5">
              {t('common.requestCustomQuote')} <ArrowRight className="h-4 w-4 ml-1" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
